import { Icon } from "@chakra-ui/react";
const CallMissedCallIcon = () => {
  return (
    <>
      <Icon
        width="5"
        height="5"
        viewBox="0 0 15 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.30789 1.62541L7.49348 4.85253L11.5452 0.747444L10.9638 0.160156L7.48755 3.67795L4.88332 1.03812H6.9062V0.160156H3.43586V3.67795H4.30196V1.62541H4.30789ZM14.2562 8.19829C12.524 6.49575 10.0918 5.43982 7.48755 5.43982C4.88332 5.43982 2.45704 6.49575 0.718909 8.19829C0.600265 8.31694 0.546875 8.43558 0.546875 8.60761C0.546875 8.78558 0.606197 8.89829 0.718909 9.01694L2.16637 10.4822C2.28501 10.6008 2.39772 10.6602 2.56976 10.6602C2.74179 10.6602 2.86043 10.6008 2.97315 10.4822C3.43586 10.0729 3.95789 9.66355 4.53332 9.36694C4.70535 9.24829 4.88332 9.07626 4.88332 8.83897V7.01778C5.69603 6.72711 6.62145 6.60846 7.54687 6.60846C8.4723 6.60846 9.39772 6.78643 10.2104 7.01778V8.83897C10.2104 9.07033 10.3291 9.24829 10.5604 9.36694C11.1418 9.65761 11.6579 10.0135 12.1206 10.4822C12.2392 10.6008 12.352 10.6602 12.524 10.6602C12.696 10.6602 12.8147 10.6008 12.9274 10.4822L14.3748 9.01694C14.4876 8.89829 14.5469 8.77965 14.5469 8.60761C14.5469 8.42965 14.3748 8.31694 14.2562 8.19829Z"
          fill="#F62D51"
        />
      </Icon>
    </>
  );
};
export default CallMissedCallIcon;
